<template>
  <PageHeader
    title="Idézetgyűjtemény"
    hero-class="bg-folkszemle hidden lg:flex"
    :breadcrumb="[ 'Folkszemle','Idézetgyűjtemény']"
  >
    <section
      @keyup.enter="$refs.search.submit()"
    >
      <search
        ref="search"
        :query-object="queryObject"
        :prop-mapping="{ themes: 'themes.type', author: 'collaborators.name' }"
        class="bg-white p-[25px]  mb-5"
        @searchChanged="searchChanged($event)"
      />
      <div 
        ref="entitiesList"
        class="bg-white w-full mt-7"
      >
        <ReOverlayLoader :loading="$fetchState.pending || isLoading">
          <RePagination
            :items="entities"
            :hide-page-selector="true"
            result-title="Idézetek száma"
          />
          <div
            v-if="entities.data.length === 0 && !$fetchState.pending"
            class="list mt-10"
          >
            <p class="text-center">
              A megadott feltételekkel nem található idézet.
            </p>
          </div>
          <div
            v-else
            class="flex flex-col gap-6 p-4 lg:px-10 lg:pt-10 place-items-center"
          >
            <nuxt-link
              v-for="(item) in entities.data"
              :key="item.id "
              class="group w-full"
              :class="{ 'opacity-30': item.status !== 'active' }"
              :to="'idezetgyujtemeny/idezet/' + item.id + '/' + item.slug"
            >
              <EntityRow 
                :image="getMainImgObj(item)"
                :no-box-slot="true"
                has-image-subtitle
                has-image-padding
                :image-subtitle="
                  (item.image.title ? ('<strong>'+ item.image.title +'</strong><br>') : '') + (item.image.subtitle ? item.image.subtitle : '')
                "
              >
                <template #body>
                  <div class="flex flex-row w-full h-full">
                    <div class="flex flex-col w-full justify-center">
                      <h2 class="font-source-serif-pro text-3xl font-semibold text-red group-hover:text-yellow">
                        {{ item.title }}
                      </h2>
                      <p class="my-[10px] text-justify">
                        {{ item.content }}
                      </p>

                      <!-- TODO atadni kepalairaskent -->
                      <!-- <p
                        v-if="item.image"
                        class="text-center"
                      >
                        <strong v-if="item.image.title">{{
                          item.image.title
                        }}</strong>
                        <br v-if="item.image.title && item.image.subtitle">
                        <span v-if="item.image.subtitle">{{
                          item.image.subtitle
                        }}</span>
                      </p> -->


                      
                      <p v-if="item.sources && item.sources.length">
                        <i
                          v-for="source in item.sources"
                          :key="source.name"
                          class="author"
                        >{{ source.source }} {{ item.source }}</i>
                      </p>


                      <div
                        v-if="item.themes && item.themes.length > 0"
                        class="mt-2"
                      >
                        <div class="flex items-stretch">
                          <img
                            class="self-start mt-1 lg:mt-[2px]"
                            src="/img/bookmark_icon.svg"
                            alt=""
                          >
                          <ul class="text-[#A4A4A4] flex flex-col lg:flex-row">
                            <li
                              v-for="(item2, index2) in item.themes"
                              :key="index2"
                              class="mr-2"
                            >
                              <nuxt-link :to="'/tallozo?search=themes.type:' + item2.type">
                                {{ item2.type }}<span v-if="index2!==item.themes.length-1">,</span>  
                              </nuxt-link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </EntityRow>
            </nuxt-link>
          </div>
        </ReOverlayLoader>
      </div>
    </section>
  </PageHeader>
</template>
<script>
import { cloneDeep } from "lodash";
import search from "~/components/folkradio/searches/QuoteSearch.vue";
import PageHeader from "~/components/folkradio/PageHeader.vue";
import ReOverlayLoader from "~/components/rxt/recomponent/ReOverlayLoader.vue";
import EntityRow from '~/components/folkradio/EntityRow.vue';
import scrollMixin from "~/mixins/scroll-fetch"

const RePagination = () =>
  import("~/components/rxt/recomponent/RePagination.vue");

export default {
  components: {
    RePagination,
    search,
    PageHeader,
    ReOverlayLoader,
    EntityRow
  },
  mixins: [scrollMixin],
  head() {
    return {
      titleTemplate: "Idézetgyűjtemény | Folkrádió",
      meta: [
        {
          hid: "title",
          name: "title",
          content: "Idézetgyűjtemény | Folkrádió"
        },
        {
          hid: "og:title",
          name: "og:title",
          content: "Idézetgyűjtemény | Folkrádió"
        },
        {
          hid: "description",
          name: "description",
          content: "Idézetek népzenéről, néptáncról, népi hagyományokról, ezek kutatásáról és továbbéléséről"
        },
        {
          hid: "og:description",
          name: "og:description",
          content: "Idézetek népzenéről, néptáncról, népi hagyományokról, ezek kutatásáról és továbbéléséről"
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          content: this.$getDomain() + "/folkszemle/idezetgyujtemeny"
        },
        {
          hid: "og:site-name",
          name: "og:site-name",
          content: this.$getDomain() + "/folkszemle/idezetgyujtemeny"
        }
      ]
    };
  },
  data() {
    return {
      queryUrl: "/quotes",
    };
  },
  watch: {
    $route(to, from) {
      this.$store.commit("search/setQueryObject", to.query);
      this.entities = {
        data: []
      }
      this.$fetch()
    }
  },
  async fetch() {
    let queryObject = { limit: 10 };

    queryObject = Object.assign(
      queryObject,
      this.$router.history.current.query
    );

    this.$store.commit("search/setQueryObject", queryObject);

    await this.search();
  },
  methods: {
    //scroll fetch method
    getQueryString(){
      const queryObject = this.queryObject;
      queryObject.sort = "-created_at";
      queryObject.limit = 10;

      this.$store.commit("search/setQueryObject", queryObject);

      return decodeURIComponent(
        this.$createQueryString(queryObject)
      );
    },
    getMainImgObj(entity) {
      if (entity.image && entity.image.url) {
        return entity.image;
      }
      return null;
    },
    getMainImg(entity) {
      if (entity.image && entity.image.url) {
        return entity.image.url;
      }
      return null;
    },
    searchChanged(queryObject) {
      this.$router.push({ query: queryObject });
    }
  }
};
</script>
